
define('text!modules/targeting/video/templates/panel.html',[],function () { return '<div class="w-box w-VideoTargeting">\n\t<div class="w-body w-panel-body"><!-- The Search & browse views render here--></div>\n\t<div class="w-foot">{{>footer}}</div>\n</div>\n';});

